export default "__VITE_ASSET__DYzPzk5z__"